import "./OurPrograms.module.css";
import Header from "@/reusable_sections/Header";
import ProgrammeOverview from "./sections/ProgrammeOverview";
import Course1AiToolsForManagers from "./sections/Course1AiToolsForManagers";
import Footer from "@/reusable_sections/Footer";
export default function OurProgramsPage() {
  return <div>
      <Header />
      <ProgrammeOverview />
      <Course1AiToolsForManagers />
      <Footer />
    </div>;
}